<template>
  <router-view />
  <Loading v-if="isLoading" />
  <ModalAlert ref="ModalAlert" />
  <ModalConfirm ref="ModalConfirm" />
</template>

<style>
@import "./assets/css/default.css";
@import "./assets/css/common.css";
</style>

<script>
import Loading from "@/components/common/LoadingBar.vue";
import ModalAlert from "@/components/common/ModalAlert.vue";
import ModalConfirm from "@/components/common/ModalConfirm.vue";
import { modalService } from "@/services/modalService";

export default {
  name: "App",
  components: {
    Loading,
    ModalAlert,
    ModalConfirm,
  },
  provide() {
    return {
      $alert: () => this.$refs.ModalAlert,
      $confirm: () => this.$refs.ModalConfirm,
    };
  },
  computed: {
    logoutReason() {
      return this.$store.getters["userStore/getLogoutReason"];
    },
    isLoading() {
      return this.$store.getters["uiStore/isLoading"];
    },
  },
  watch: {
    async logoutReason(reason) {
      if (!reason) return;

      this.$store.dispatch("userStore/RESET_LOGOUT_REASON");

      if (reason === "expired") {
        // 만료된 시점의 현재 경로를 기억 → 재로그인 후 그 페이지로 복귀
        const current = this.$route;
        const redirect =
          current.name === "Login" ||
          current.path.startsWith("/sso") ||
          current.path.startsWith("/sign-up")
            ? undefined
            : encodeURIComponent(current.fullPath);
        // 확인 클릭 후 로그인 페이지로 이동
        await this.$refs.ModalAlert.show({
          content: "세션이 만료되었습니다.<br />다시 로그인해주세요.",
        });
        this.$router
          .replace({ name: "Login", query: redirect ? { redirect } : {} })
          .catch(() => {});
      } else {
        this.$router.replace("/").catch(() => {});
      }
    },
  },
  mounted() {
    modalService.register(this.$refs.ModalAlert, this.$refs.ModalConfirm);
    this.contentHeadSticky();
  },
  methods: {
    contentHeadSticky() {
      document.addEventListener("scroll", function () {
        let contentHead = document.querySelector(".container");
        if (contentHead == null) return;
        let currentScroll = document.documentElement.scrollTop;
        if (currentScroll > 400) {
          contentHead.classList.add("container--sticky");
        } else {
          contentHead.classList.remove("container--sticky");
        }
      });
    },
  },
};
</script>
